'use strict';
import util from './util';


/**
 * @function getConsent Used to display/control of the modal containing the consent management message
 **/

function getConsent() {
	$.get(util.appendParamsToUrl(Urls.consentTracking, {
		"format": "ajax"
	}), function (data) {

		$(document).find('body #main').append("<div class='cookie_popup_container'><div class='popup_overlay'/><div class='cookie_consent_popup'>" + data + "</div></div>");

		$(document).find('.cookie_consent_popup .trackingYes').on('click', function () {
			$.ajax({
				type: 'GET',
				url: util.appendParamToURL(Urls.consentTrackingSetSession, 'consentTracking', true),
				success: function () {
					showPrivacyDialog();
				},
				error: function () {
					showPrivacyDialog();
				}
			})
			$('.cookie_popup_container').remove();
		});

		$(document).find('.cookie_consent_popup .trackingNo').on('click', function () {
			$.ajax({
				type: 'GET',
				url: util.appendParamToURL(Urls.consentTrackingSetSession, 'consentTracking', false),
				success: function () {
					showPrivacyDialog();
				},
				error: function () {
					showPrivacyDialog();
				}
			})
			$('.cookie_popup_container').remove();
		});

	});
}

function enablePrivacyCookies() {
	if (document.cookie.indexOf('dw=1') < 0) {
		document.cookie = 'dw=1; path=/';
	}
	if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
		document.cookie = 'dw_cookies_accepted=1; path=/';
	}
}

function showPrivacyDialog() {

	if (SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
		// check for privacy policy page
		if ($('.privacy-policy').length === 0) {
			$.get(util.appendParamsToUrl(Urls.cookieHint, {
				"format": "ajax"
			}), function (data) {
				$(document).find('body #main').append("<div class='cookie_consent_popup'>" + data + "</div>");
				$(document).find('.cookie_consent_popup .agreeButton').on('click', function () {
					$('.cookie_consent_popup').hide();
				});
				enablePrivacyCookies();
			});
		}
	} else {
		// Otherwise, we don't need to show the asset, just enable the cookies
		enablePrivacyCookies();
	}
}
var consentTracking = {
	init: function () {
		if (consent == null && SitePreferences.CONSENT_TRACKING_HINT) { // eslint-disable-line no-undef
			getConsent();
		}

		if (consent != null && SitePreferences.CONSENT_TRACKING_HINT) { // eslint-disable-line no-undef
			showPrivacyDialog();
		}

	},
	show: function () {
		getConsent();
	}
};
export default consentTracking;